
import { computed, watchEffect } from 'vue'
import store from '../store'

const auth_user = computed(() => store.getters['Auth/permissions'])
let authUserLoaded = false

watchEffect(() => {
  if (auth_user.value && !authUserLoaded) {
    // auth_user has loaded
    authUserLoaded = true
    // Call your function that uses auth_user here
  }
})

function actionChecker(name: string, action:string) {
  if (!auth_user.value) {
    // auth_user has not loaded yet
    return false
  }
  
  return auth_user.value.find((element: any) => {
    if (element.name === name && element.action === action) {
      return true
    }
  })
}

export default actionChecker
